import {
    Component, OnInit, AfterViewInit, Input, ViewChild, ViewContainerRef,
    ComponentFactoryResolver, ComponentFactory, Output, EventEmitter
} from '@angular/core';
import {LeaderTalkComponent} from "../leader-talk/leader-talk.component";
import {StaffTalkComponent} from "../staff-talk/staff-talk.component";
import {SmallGuideComponent} from "../small-guide/small-guide.component";
import {BigGuideComponent} from "../big-guide/big-guide.component";
import {ExpertHintsComponent} from "../expert-hints/expert-hints.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";

declare var jquery:any;
declare var $ :any;

@Component({
    selector: 'app-case-practice-main',
    templateUrl: './case-practice-main.component.html',
    styleUrls: ['./case-practice-main.component.css',]
})
export class CasePracticeMainComponent implements OnInit , AfterViewInit{
    @ViewChild("talkContainer", { read: ViewContainerRef }) talkContainer: ViewContainerRef;

    @Input() currentCase: any;
    @Input() caseType: any;
    @Input() headImageUrl: string;
    @Input() practiceMetaId: number;
    @Input() practiceId: number;

    @Output() onFinish = new EventEmitter<string>();
    @Output() onExit = new EventEmitter<any>();

    picture: number;
    progress: number = 0;
    choiceBtnDisable: boolean;

    choiceClickable:boolean;

    started:boolean;

    sceneText:string;
    questionOptions: any;
    exitTipMessage: string;

    buttonTitle: string;
    caseFinished: boolean;

    leaderTalkComponentFactory: ComponentFactory<LeaderTalkComponent>;
    staffTalkComponentFactory: ComponentFactory<StaffTalkComponent>;
    smallGuideComponentFactory: ComponentFactory<SmallGuideComponent>;
    bigGuideComponentFactory: ComponentFactory<BigGuideComponent>;
    expertHintsComponentFactory: ComponentFactory<ExpertHintsComponent>;

    currentQuestion: any;
    currentQuestionIndex: number;

    dynamicPoint:string;

    shadeClickable:boolean;
    scrollTop:number;

    transtionStatus:boolean;
    isOpenClass:number;
    practiceIndex:number;
    isHarmonyOS = false; //是否鸿蒙系统

    constructor(private componentResolver: ComponentFactoryResolver,
                private route: ActivatedRoute,
                private router: Router,
                private  apiService: ApiService,
                private commonService: CommonService) { 
                }

    ngOnInit() {
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        console.log(this.currentCase)
        let index = this.getIndexByConditionIdInLists(this.currentCase.questions,'id',this.currentCase.currentQuestionId);
         this.practiceIndex = this.currentCase.name=='辅导1' ? 1:2;
        if(localStorage.getItem('progress'+this.currentCase.id)){
          this.progress = Number(localStorage.getItem('progress'+this.currentCase.id));
        }else{
          this.progress = this.currentCase.finishedQuestions === 0 ? 0 : Math.floor(this.getNumberPlace(Number(this.currentCase.questions[index].options[this.currentCase.currentOptionId-1].nextQuestionId))*(100/this.currentCase.questions.length));
        }
        localStorage.setItem('progress'+this.currentCase.id,String(this.progress));
        // this.progress = this.currentCase.finishedQuestions === 0 ? 0 : Math.floor(this.getNumberPlace(Number(this.currentCase.currentQuestionId))*(100/this.currentCase.questions.length));
        this.isOpenClass = Number(localStorage.getItem('openClass'))?1:0;
        this.choiceBtnDisable=true;
        this.choiceClickable=true;
        this.buttonTitle = "开始谈话";
        this.caseFinished = false;
        this.exitTipMessage = this.caseType == "quiz" ? "巩固练习一旦中断，需要重新开始，确认退出吗？" : "情景模拟还未完成，确认退出吗？";
        this.leaderTalkComponentFactory  = this.componentResolver.resolveComponentFactory(LeaderTalkComponent);
        this.staffTalkComponentFactory  = this.componentResolver.resolveComponentFactory(StaffTalkComponent);
        this.smallGuideComponentFactory  = this.componentResolver.resolveComponentFactory(SmallGuideComponent);
        this.bigGuideComponentFactory  = this.componentResolver.resolveComponentFactory(BigGuideComponent);
        this.expertHintsComponentFactory  = this.componentResolver.resolveComponentFactory(ExpertHintsComponent);

        this.sceneText = this.currentCase.description;

        this.scrollTop=0;
        this.started = false;

        this.dynamicPoint='';
        this.shadeClickable = false;

        this.transtionStatus = false;

        if(this.practiceMetaId==2){
            $("#title2").text("情景模拟");
            $("#title").text("情景模拟");
        }else{
            $("#title2").text("案例练习");
            $("#title").text("案例练习");
        }

        
        if(this.currentCase.name=='辅导1'){
            this.picture = 1;
        }else if(this.currentCase.name == '辅导大健康'){
            this.picture = 305;
        }else if(this.currentCase.name == '辅导金融'){
            this.picture = 315;
        }else if(this.currentCase.name == '辅导互联网'){
            this.picture = 325;
        }else if(this.currentCase.name == '辅导国企'){
            this.picture = 335;
        }else{
            this.picture = 2;
        }
        //全局变量初始化为 null
        if(this.currentCase && this.currentCase.id){
        	window["exercises" + this.currentCase.id] = null;
        }
        const exerciseMetaId=$('#exerciseMetaId').val()
        this.apiService.learingTime({learningPathMetaId:this.isOpenClass===1?$('#learningPathMetaIdContainer').val():localStorage.getItem("learningPathMetaId"),module:'情景模拟',courseUnit:'',type:1,btnName:exerciseMetaId||localStorage.getItem("exerciseMetaId"),userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
        })
        this.commonService.sendPostMessage(0,'isPractice' +'Complete')
    }

    initializeTalk() {
        this.talkContainer.clear();
        var that = this;
        if (this.caseType == "quiz") {
            setTimeout(function () {
                that.choiceBtnDisable = false;
            }, 1500);
        }
        else {
            this.initializeExerciseTalk()
        }
    }

  //根据条件在数组中获取下标
  getIndexByConditionIdInLists(Lists,condition,value){
    return (Lists||[]).findIndex((v)=>v[condition] === value);
  }


  initializeExerciseTalk () {
        var that = this;
        var question = this.currentCase.questions[0];

        var i = 0;
        if (this.currentCase.finishedQuestions > 0) {
            this.started = true;
            this.buttonTitle = "打开选项卡进行选择";

            do {
                let staffRef = this.talkContainer.createComponent(this.staffTalkComponentFactory);
                staffRef.instance.talk = question.description;
                staffRef.instance.picture = this.picture;

                if (i > 0) {
                    let talkDesc = question ? question.directorComment : "贺电贺电~辅导完成，可以在报告中看到你这次的表现如何哦~";
                    if (talkDesc && talkDesc != "") {
                        let bigGuideRef = this.talkContainer.createComponent(this.bigGuideComponentFactory);
                        bigGuideRef.instance.content = talkDesc;
                    }
                }

                i++;

                let option = question.options.find(o => o.selected == true);
                if (!option) {
                    this.currentQuestion = question;
                    break;
                }

                let leaderRef = this.talkContainer.createComponent(this.leaderTalkComponentFactory);
                leaderRef.instance.talk = option.description;
                leaderRef.instance.headImageUrl = this.headImageUrl;
                leaderRef.instance.learningPathMetaId = Number(this.practiceMetaId);

                question = null;
                for(var i = 0; i < this.currentCase.questions.length; i++)
                {
                    if (this.currentCase.questions[i].id == option.nextQuestionId) {
                        question = this.currentCase.questions[i];
                        break;
                    }
                }

                if (!question) {
                    break;
                }
            }
            while (true);


            /*alert(JSON.stringify(document.querySelectorAll(".talk_item")));*/


            this.currentQuestion = question;

            this.initializeOptions();

            that.choiceBtnDisable = false;

            setTimeout( function () {
                that.scrollToBottom(true);
            }, 100);
        }
        else {
            this.currentQuestion = question;
            setTimeout(function () {
                that.choiceBtnDisable = false;
            }, 1000);
        }
    }

    createStorageInput(id){
      let html = '<input type="hidden" id="practice'+ id +'" value="" />';
      $('body').append(html);
    }

    initializeQuizTalk() {
        this.currentQuestionIndex = 0;
        this.initialCommonOfNewTalk();
    }

    initialCommonOfNewTalk() {
        var that = this;
        this.currentQuestion = this.currentCase.questions[0];

        setTimeout(function () {
            let leaderRef = that.talkContainer.createComponent(that.leaderTalkComponentFactory);
            leaderRef.instance.talk = that.currentCase.guide;
            leaderRef.instance.headImageUrl = that.headImageUrl;

            that.scrollToBottom();
        }, 500);

        setTimeout(function () {
            let responseRef = that.talkContainer.createComponent(that.staffTalkComponentFactory);
            responseRef.instance.talk = that.currentCase.response;
            responseRef.instance.picture = this.picture;

            that.scrollToBottom();
        }, 1500);

        setTimeout(function () {
            let startDespRef = that.talkContainer.createComponent(that.smallGuideComponentFactory);
            startDespRef.instance.content = that.currentCase.startDescription;

            that.scrollToBottom();
        }, 2500);

        this.initializeOptions();
        setTimeout(function () {
            that.choiceBtnDisable = false;
        }, 3500);
    }

    initializeOptions() {
        if (!this.currentQuestion || (!this.currentQuestion.options || this.currentQuestion.options.length <= 0)) {
            this.showFinishButton();

            return;
        }

        this.questionOptions = this.currentQuestion.options.sort(function(){
            return 0.5 - Math.random();
        });
    }

    ngAfterViewInit(){
        this.commonService.initPage({
            'backgroundColor':'white'
        });

        var choiceBox=document.getElementById("choice");
        var choiceBtn=document.getElementById("choiceBtn");
        var choiceBoxHeight=choiceBox.offsetHeight;
        var bodyHeight=document.body.offsetHeight;
        choiceBox.style.top=bodyHeight + 'px';
        choiceBox.style.maxHeight=document.body.offsetHeight*0.99 + 'px';
        /*document.getElementById("wrap").style.paddingBottom = "0.98rem";*/

        //this.showSceneText();

        this.initializeTalk();

        /*let headWrapHeightMax = 1.3*this.commonService.rootFontSize();
        let headWrapHeightMax2 = document.getElementById("head_wrap").offsetHeight*2-0.2*this.commonService.rootFontSize();
        let headWrapHeightMin = 0.6*this.commonService.rootFontSize();


        $("#wrap").on("scroll",function(){

            let height = headWrapHeightMax - $("#wrap").scrollTop();
            if($("#wrap").scrollTop()>headWrapHeightMin){
                document.getElementById("head_wrap").style.height=headWrapHeightMin+"px";
                document.getElementById("title2").style.opacity="1";
            }else{
                document.getElementById("title2").style.opacity="0";
                document.getElementById("head_wrap").style.height=headWrapHeightMax+"px";
            }
        });*/

        /*alert(JSON.stringify(document.querySelectorAll(".talk_item")));*/

    }

    showSceneText(){
        document.getElementById("sceneText_1").style.marginTop= 0 + 'px';
        document.getElementById("sceneText_1").style.opacity= "1";
    }


    onChoiceBtnClick(){
        var that = this;
        document.getElementById("choice").style.display="block";
        this.choiceClickable = true;
        if (!this.started) {
            this.started = true;
            this.buttonTitle = this.caseType == "quiz" ? "点击进行选择" : "打开选项卡进行选择";
            this.choiceBtnDisable = true;

            if (this.caseType == "exercise") {
                setTimeout(function () {
                    let staffRef = that.talkContainer.createComponent(that.staffTalkComponentFactory);
                    staffRef.instance.talk = that.currentQuestion.description;
                    staffRef.instance.picture = that.picture;

                    that.scrollToBottom();
                }, 2000);

                this.initializeOptions();
                setTimeout(function () {
                    that.choiceBtnDisable = false;
                }, 3500);
            }
            else if(this.caseType == "quiz") {
                this.initializeQuizTalk();
            }
        }
        else {
            if (!this.caseFinished) {
                let choiceBox = document.getElementById("choice");
                let bodyHeight=document.body.offsetHeight;
                let choiceBoxHeight = choiceBox.offsetHeight;
                this.shadeClickable = true;
                if (!this.choiceBtnDisable) {
                    choiceBox.style.top = bodyHeight-choiceBoxHeight + 'px';
                    $("#shade").fadeIn(500);
                    this.disableRolling();
                }
            }
            else {
                this.shadeClickable = false;
                let that = this;
                /*if (this.caseType == "quiz") {
                    this.apiService.finishQuiz("" + this.currentCase.id + "").subscribe(practice => {
                    });
                }
                else {
                    this.apiService.finishExercise("" + this.currentCase.id + "").subscribe(practice => {
                    });
                }*/

                this.apiService.finishExercise("" + this.currentCase.id + "").subscribe(practice => {
                    this.apiService.getKasInfos(this.currentCase.id,this.practiceId).subscribe((result)=>{
                        if(result){
                          this.apiService.getLevelInfo(result.reports[0]);
                        }
                    })
                    if(localStorage.getItem('isIframe')){
                      window.parent.postMessage({
                        isPracticeComplete: 2,
                      },'*');
                    }else{
                      $("#shade").show();
                      $("#toast").fadeIn(500);
                      this.disableRolling();
                      setTimeout(function () {

                        // that.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟'+Number(localStorage.getItem('exerciseMetaId'))}).then();
                        that.onFinish.emit(that.currentCase.id);
                      }, 3000);

                      setInterval(function () {
                        if(that.dynamicPoint=='...'){
                          that.dynamicPoint='';
                        }else{
                          that.dynamicPoint+='.';
                        }
                      },200);
                    }
                });
            }
        }
    }

    onChoiceClick(option,i:number){
        if(this.choiceClickable){
            var that = this;
            setTimeout(function () {
                document.getElementById("choice").style.display="none";
            },500);
            var choiceBox=document.getElementById("choice");
            var choiceBoxHeight=choiceBox.offsetHeight;
            let bodyHeight=document.body.offsetHeight;
            choiceBox.style.top = bodyHeight + "px";

            this.choiceBtnDisable = true;
            this.choiceClickable = false;

            $(".choiceItem").eq(i).css({
                "background-color":"#acbad8",
                "color":"white"
            });

            var questionId = this.currentQuestion.id;
            option.selected = true;

            $("#shade").fadeOut(1000);
            this.enableRolling();

            if (this.caseType == "quiz") {
                this.apiService.answerQuizQuestion("" + this.currentCase.id + "", questionId, option.id).subscribe(practice => {
                });
				//全局缓存最后提交数据
				let exerciseConfig = {
					questionId:questionId,
					optionId:option.id,
					exercisesId:this.currentCase.id
				};
				window["exercises" + this.currentCase.id] = exerciseConfig;
                this.currentQuestionIndex++;
                if (this.currentQuestionIndex < this.currentCase.questions.length) {
                    this.currentQuestion = this.currentCase.questions[this.currentQuestionIndex];
                }
                else {
                    this.currentQuestion = null;
                }
            }
            else {
                let totalStep = this.currentCase.questions.length;
                this.progress = Number(questionId)>=Number(option.nextQuestionId) ? Math.floor(this.getNumberPlace(Number(questionId)+1)*(100/totalStep)) : Math.floor(this.getNumberPlace(Number(option.nextQuestionId))*(100/totalStep));
                console.log(this.progress)
                if(this.progress < Number(localStorage.getItem('progress'+this.currentCase.id))){
                    console.log(1111)
                  this.progress = Number(localStorage.getItem('progress'+this.currentCase.id))+1;
                }else{
                    console.log(222)
                  this.progress = this.progress;
                }
                localStorage.setItem('progress'+this.currentCase.id,String(this.progress));
                // this.progress = Math.floor(this.getNumberPlace(Number(option.nextQuestionId))*(100/this.currentCase.questions.length));
                $('#practice'+this.currentCase.id).val(this.progress);
                this.apiService.answerExerciseQuestion("" + this.currentCase.id + "", questionId, option.id).subscribe(practice => {
                });
				//全局缓存最后提交数据
				let exerciseConfig = {
					questionId:questionId,
					optionId:option.id,
					exercisesId:this.currentCase.id
				};
				window["exercises" + this.currentCase.id] = exerciseConfig;
                var nextQuestion = null;
                for(var i = 0; i < this.currentCase.questions.length; i++)
                {
                    if (this.currentCase.questions[i].id == option.nextQuestionId) {
                        nextQuestion = this.currentCase.questions[i];
                        break;
                    }
                }

                this.currentQuestion = nextQuestion;
            }

            let leaderRef = this.talkContainer.createComponent(this.leaderTalkComponentFactory);
            leaderRef.instance.talk = option.description;
            leaderRef.instance.learningPathMetaId = Number(this.practiceMetaId);
            leaderRef.instance.headImageUrl = this.headImageUrl;

            this.scrollToBottom();
            let baseTime = 0;
            if (this.caseType == "quiz") {
                setTimeout(function () {
                    let expertDespRef = that.talkContainer.createComponent(that.expertHintsComponentFactory);
                    expertDespRef.instance.title = option.feedbackTitle;
                    expertDespRef.instance.content = option.feedbackDescription;
                    expertDespRef.instance.isExcellent = option.feedbackRank > 4;

                    that.scrollToBottom();
                }, 1500);

                setTimeout(function () {
                    if (that.currentQuestion) {
                        let staffRef = that.talkContainer.createComponent(that.staffTalkComponentFactory);
                        staffRef.instance.talk = that.currentQuestion.description;
                        staffRef.instance.picture = that.picture;
                        that.scrollToBottom();
                    }
                }, 3000);

                baseTime = 3000;
            }
            else {
                if (this.currentQuestion) {
                    setTimeout(function () {
                        let staffRef = that.talkContainer.createComponent(that.staffTalkComponentFactory);
                        staffRef.instance.talk = that.currentQuestion.description;
                        staffRef.instance.picture = that.picture;

                        that.scrollToBottom();
                    }, 1500);

                    baseTime = 1500;
                }

                setTimeout(function () {
                    let talkDesc = that.currentQuestion ? that.currentQuestion.directorComment : "贺电贺电~辅导完成，可以在报告中看到你这次的表现如何哦~";
                    if (talkDesc && talkDesc != "") {
                        let bigGuideRef = that.talkContainer.createComponent(that.bigGuideComponentFactory);
                        bigGuideRef.instance.content = talkDesc;
                    }

                    that.scrollToBottom();
                }, baseTime + 1500);
            }

            setTimeout(function () {
                if (!that.currentQuestion || (!that.currentQuestion.options || that.currentQuestion.options.length <= 0)) {
                    that.showFinishButton();
                }
                else {
                    that.initializeOptions();
                    that.choiceBtnDisable = false;
                }
            }, baseTime + 2000);
        }
    }

    showFinishButton() {
        this.buttonTitle = "完成，查看报告";
        this.progress = 100;
        localStorage.removeItem('progress'+this.currentCase.id);
        this.caseFinished = true;
        this.choiceBtnDisable = false;
    }

    close() {
        $("#shade").show();
        $("#tip1").fadeIn(500);
        this.disableRolling();
    }

    continue() {
        $("#tip1").fadeOut(500)
        $("#shade").hide();;
    }

    exit() {
      // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟'+Number(localStorage.getItem('exerciseMetaId'))}).then();
        this.onExit.emit(true);
        const exerciseMetaId=$('#exerciseMetaId').val()
        this.apiService.learingTime({learningPathMetaId:this.isOpenClass===1?$('#learningPathMetaIdContainer').val():localStorage.getItem("learningPathMetaId"),module:'情景模拟',courseUnit:'',type:2,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
        })
        console.log(exerciseMetaId)
        this.commonService.sendPostMessage(1,'isPractice' +'Complete')
    }

    scrollToBottom(disableAnimate:boolean = false) {
        if(disableAnimate){
            $("#wrap").scrollTop($("#wrap")[0].scrollHeight);
        }else{
            $('#wrap').animate({scrollTop:$("#wrap")[0].scrollHeight}, 800);
        }
    }

    test(){
        this.initializeTalk();
    }

    onShadeClick(){
        if(this.shadeClickable){
            $("#shade").fadeOut(500);
            this.enableRolling();
            this.shadeClickable = false;
            let choiceBox = document.getElementById("choice");
            let bodyHeight=document.body.offsetHeight;
            choiceBox.style.top=bodyHeight+"px";
        }
    }

    getNumberPlace(num){
      if(num > 0){
        for(let i = 0, len = String(num).length; i<len; i+=1){
          return Number(String(num)[String(num).length-2]+String(num)[String(num).length-1]);
        }
      }
    }

    disableRolling(){
        document.getElementById('shade').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('toast').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('tip1').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('choice').ontouchmove = function(e){ e.preventDefault(); }
        //document.getElementById('wrap').classList.add('disableScrolling');
    }

    enableRolling(){
        //document.getElementById('wrap').classList.remove('disableScrolling');
        //$('html,body').animate({scrollTop:$('#bottom').offset().top}, 0);
    }}



// WEBPACK FOOTER //
// ./src/app/case-practice-main/case-practice-main.component.ts